import { Center, Input, Select, Stack } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { Subtipo_inmueble, Tipologia_inmueble } from '../../data/constants';
import { getAllLocalidades } from '../../services/agencias';

const FiltroPedidos = ({ setFiltros }) => {
	const [tipologia, setTipologia] = useState('');
	const [subtipologia, setSubtipologia] = useState('');

	const [localidades, setLocalidades] = useState([]);

	const [needReload, setNeedReload] = useState(true);

	const subtiposDisponibles =
		Subtipo_inmueble.find(item => item.tipo === tipologia)?.subtipo || [];

	const handleTipologiaChange = e => {
		const selectedTipologia = e.target.value;
		setTipologia(selectedTipologia);
		setSubtipologia(''); // reset subtipologia al cambiar la tipologia
		setFiltros(e); // actualiza el filtro padre
	};

	const handleSubtipologiaChange = e => {
		setSubtipologia(e.target.value);
		setFiltros(e);
	};

	useEffect(() => {
		const fetchLocalidades = async () => {
			setNeedReload(false);

			try {
				const request = await getAllLocalidades();
				setLocalidades(request);
			} catch (error) {
				console.error('🚀 ~ fetchLocalidades ~ error:', error);
			}
		};
		needReload && fetchLocalidades();
	}, [needReload]);

	return (
		<Center>
			<Stack direction='column' spacing={0} align='center'>
				<Stack w='100%'>
					<Input
						rounded='none'
						placeholder='Buscar'
						name='busqueda'
						onChange={setFiltros}
					/>
				</Stack>
				<Stack direction='row' spacing={4} align='center'>
					<Stack>
						<Select
							size='xs'
							placeholder='-- Estado --'
							name='estadoPedido'
							onChange={setFiltros}
						>
							<option value='En proceso'>En proceso</option>
							<option value='Cerrado'>Cerrado</option>
							<option value='Cancelado'>Cancelado</option>
						</Select>
					</Stack>
					<Stack>
						<Select
							size='xs'
							placeholder='-- Motivo --'
							name='contrato'
							onChange={setFiltros}
						>
							<option value='Compra'>Compra</option>
							<option value='Alquiler'>Alquilar</option>
						</Select>
					</Stack>
					<Stack>
						<Select
							size='xs'
							placeholder='-- Tipología --'
							name='tipologiaInmueble'
							value={tipologia}
							onChange={handleTipologiaChange}
						>
							{Tipologia_inmueble.map((tipo, index) => {
								return (
									<option key={index} value={tipo.tipo}>
										{tipo.tipo}
									</option>
								);
							})}
						</Select>
					</Stack>
					<Stack>
						<Select
							size='xs'
							placeholder='-- Subtipología --'
							name='subtipologiaInmueble'
							value={subtipologia}
							onChange={handleSubtipologiaChange}
						>
							{subtiposDisponibles.map((tipo, index) => {
								return (
									<option key={index} value={tipo.tipo}>
										{tipo.tipo}
									</option>
								);
							})}
						</Select>
					</Stack>
					<Stack>
						<Select
							size='xs'
							placeholder='-- Localidades --'
							name='localidad'
							onChange={setFiltros}
						>
							<option value=''>Todas</option>
							{localidades.map(localidad => {
								return (
									<option key={localidad} value={localidad}>
										{localidad}
									</option>
								);
							})}
						</Select>
					</Stack>
					<Stack>
						<Select
							size='xs'
							placeholder='-- Modalidad pago --'
							name='contado'
							onChange={setFiltros}
						>
							<option value=''>Todas</option>
							<option value='true'>Contado</option>
							<option value='false'>Financiado</option>
						</Select>
					</Stack>
					<Stack>
						<Select
							size='xs'
							placeholder='-- Creación --'
							name='orden'
							onChange={setFiltros}
						>
							<option value='asc'>Antiguas primero</option>
							<option value='desc'>Recientes primero</option>
						</Select>
					</Stack>
				</Stack>
			</Stack>
		</Center>
	);
};

export default FiltroPedidos;
